import { Section } from '@web_opxp/components';
import React from 'react';
import './SideBarSection.scss';

interface ISideBarSectionProps {
  sidebar: React.ReactElement;
}

const SideBarSection = ({ sidebar, children }: React.PropsWithChildren<ISideBarSectionProps>) => {
  return (
    <Section className="SideBarSection">
      <div className="row SideBarSectionContainer">
        {sidebar}
        {children}
      </div>
    </Section>
  );
};
export default SideBarSection;
